import MessageBus from '@mtt/postal-kit';
import { createMachine, interpret } from 'xstate';
import { config, options } from '../../logic/main';
import * as actions from './shared/actions';

const reduxDevToolsEnabled =
  process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';

const loggerEnabled =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_MTT_LOGGER === 'true';

const createLogger = prefix => ({
  log: (...args) => {
    console.log(`%c${prefix}`, 'color:red', ...args);
  },
});

const lg = createLogger('gaming-lobby.mtt.framework');

const transitionLogger = loggerEnabled
  ? (state, event, action) => {
      lg.log(event);
    }
  : () => {};

const services = {};
const guards = {};
const machine = createMachine(config, {
  ...options,
  services: {
    ...(options.services || {}),
    ...services,
  },
  actions: {
    ...(options.actions || {}),
    ...actions,
  },
  guards: {
    ...(options.guards || {}),
    ...guards,
  },
});
const interpreter = interpret(machine, {
  devTools: reduxDevToolsEnabled,
}).onTransition(transitionLogger);

MessageBus.subscribe({
  topic: 'wh.mtt.command.logic.start',
  callback: () => {
    interpreter.start();
  },
});
MessageBus.subscribe({
  topic: 'wh.mtt.command.logic.stop',
  callback: () => {
    interpreter.stop();
  },
});
MessageBus.subscribe({
  topic: 'wh.mtt.command.logic.send',
  callback: data => {
    interpreter.send(data);
  },
});
